/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewAbout_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly about: string | null;
    } | null;
    readonly " $refType": "OverviewAbout_tradeFirm";
};
export type OverviewAbout_tradeFirm$data = OverviewAbout_tradeFirm;
export type OverviewAbout_tradeFirm$key = {
    readonly " $data"?: OverviewAbout_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewAbout_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "OverviewAbout_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "about",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '7a8a1f8215aa6ead1bf77b2bf2301190';
export default node;
